import { createAuthClient } from "better-auth/react";

/**
 * Same-origin auth client. better-auth requires an absolute baseURL, so we
 * build one from `window.location.origin`. In dev Vite proxies /api →
 * wrangler dev:8787; in prod a Pages function sends /api/* to the Worker.
 * Either way the cookie stays first-party.
 */
const baseURL =
  typeof window !== "undefined"
    ? `${window.location.origin}/api/auth`
    : "http://localhost:5173/api/auth";

export const authClient = createAuthClient({
  baseURL,
  fetchOptions: {
    credentials: "include",
  },
});

export const { signIn, signUp, signOut, useSession, getSession } = authClient;
